export type ContactVisibility = 'all' | 'filtered';

/**
 * Red de seguridad defensiva: los formularios inicializan "Visualizado por"
 * con [], pero si el valor llegara undefined/null igual se envía un arreglo,
 * porque el backend exige siempre uno ([] = todas las compañías).
 */
export const normalizeCompanyIds = (value?: number[] | null): number[] =>
  Array.isArray(value) ? value : [];

/**
 * "Ver todo" siempre envía [] (aunque queden compañías elegidas ocultas);
 * "Filtrado por" envía la selección.
 */
export const resolveCompanyIds = (
  visibility?: ContactVisibility | null,
  value?: number[] | null
): number[] => (visibility === 'filtered' ? normalizeCompanyIds(value) : []);

export const visibilityFromCompanyIds = (
  companyIds?: number[] | null
): ContactVisibility =>
  normalizeCompanyIds(companyIds).length > 0 ? 'filtered' : 'all';
